/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
'use strict';

module.exports = class Request {
	constructor({ name = 'Request' } = {}) {
		this._name = name;
	}

	send() {
		return Promise.reject(
			new Error('Method send() must be implemented by subclass.')
		);
	}
};



// WEBPACK FOOTER //
// ../gateway-client/src/requests/Request.js